<template>
  <div class="cursor">
    <div ref="pointer" class="cursor__inner cursor__inner--pointer" :style="styles.pointer"></div>
    <div ref="circle" class="cursor__inner cursor__inner--circle" :style="styles.circle"></div>
  </div>
</template>

<script>
export default {
  name: 'Mouse',
  props: {
    size: {
      type: Object,
      required: true
    },
    progress: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      renderedStyles: {
        tx: {previous: 0, current: 0, amt: 0.2},
        ty: {previous: 0, current: 0, amt: 0.2},
        scale: {previous: 1, current: 1, amt: 0.2}
      }
    }
  },
  computed: {
    styles () {
      return {
        pointer: {
          top: `${(this.size.circle - this.size.pointer + 1)/2}px`,
          left: `${(this.size.circle - this.size.pointer + 1)/2}px`,
          width: `${this.size.pointer}px`,
          height: `${this.size.pointer}px`,
          transform: `translate3D(${this.progress.pointer.x}px, ${this.progress.pointer.y}px, 0)`
        },
        circle: {
          width: `${this.size.circle}px`,
          height: `${this.size.circle}px`,
          transform: `translate3D(${this.progress.circle.x}px, ${this.progress.circle.y}px, 0) scale(${this.progress.scale})`
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .cursor {
    display: none;

    @media (any-pointer: fine) {
      display: block;

      &__inner {
        z-index: 9999;
        pointer-events: none;
        position: absolute;
        top: 0;
        left: 0;
        mix-blend-mode: difference;
        border-radius: 50%;

        &--pointer {
          background-color: $white;
        }
        
        &--circle {
          border: 1px solid $eggshell;
        }
      }
    }
  }
</style>

<style lang="scss">
  @media (any-pointer: fine) {
    * {
      cursor: none;
    }
  }
</style>